import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { useSingleUserControl } from "../../../context/SuperAdmin/SingleUserControlContext";
import { formatFecha, formatFechaWithHour } from "../../../utils/dateFunctions";
import EstadoBadge from "./EstadoBadge";

const SuscriptTable = () => {
  const { suscriptions } = useSingleUserControl();

  const estadoMap: Record<string, "success" | "warning" | "wrong" | "unknown"> =
    {
      Activo: "success",
      Inactivo: "warning",
      Eliminado: "wrong",
    };

  return (
    <TableContainer
      sx={{
        fontFamily: "Montserrat, sans-serif",
        boxShadow: "none",
        color: "#005559",
        px: 2,
      }}
    >
      <Table
        sx={{
          borderCollapse: "collapse",
          "& .MuiTableCell-root": {
            fontFamily: "Montserrat, sans-serif",
            padding: "6px 12px",
            borderBottom: "none",
            color: "#005559",
          },
        }}
      >
        <TableHead>
          <TableRow
            sx={{
              borderBottom: "1px solid #336B8780", // más gruesa para el header
            }}
          >
            <TableCell sx={{ fontWeight: 700 }}>Plan</TableCell>
            <TableCell sx={{ fontWeight: 700 }}>Fecha de Inicio</TableCell>
            <TableCell sx={{ fontWeight: 700 }}>Fecha de Expiración</TableCell>
            <TableCell sx={{ fontWeight: 700 }}>Créditos Usados</TableCell>
            <TableCell sx={{ fontWeight: 700 }}>Estado</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {suscriptions.length === 0 ? (
            <TableRow>
              <TableCell
                colSpan={5}
                align="center"
                sx={{
                  fontStyle: "italic",
                  color: "#7A7A7A",
                  py: 2,
                }}
              >
                No hay suscripciones
              </TableCell>
            </TableRow>
          ) : (
            suscriptions.map((row, index) => (
              <TableRow
                key={index}
                sx={{
                  "&:hover": { backgroundColor: "#f5f5f5" },
                  borderBottom:
                    index === suscriptions.length - 1
                      ? "none"
                      : "1px solid #e0e0e0",
                }}
              >
                <TableCell>{row.plan}</TableCell>
                <TableCell>{formatFechaWithHour(row.fecha_asignacion)}</TableCell>
                <TableCell>{formatFecha(row.fecha_fin)}</TableCell>
                <TableCell>{row.creditos_gastados}</TableCell>
                <TableCell>
                  <EstadoBadge estado={estadoMap[row.estado]}>
                    {row.estado}
                  </EstadoBadge>
                </TableCell>
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default SuscriptTable;
